import type { AxiosResponse } from 'axios';
import { BaseApi } from '../../core/api';
import { getInitials } from '../../core/models';
import type { BaseUser, UserPreferences } from '../../core/models/user';
import type { RootState } from '../reducers';
import actions from './actions';

const { setUserCurrentWorkspace } = actions;

export const loadCropwiseUser = () => async (dispatch, getState) => {
  dispatch(actions.LOAD_CROPWISE_USER.started());

  const state: RootState = getState();
  const { currentWorkspaceId } = state.User;

  try {
    const response = await BaseApi.get<BaseUser, AxiosResponse<BaseUser>>('/accounts/me', {
      params: { include_extended: true },
    });

    const baseUser: BaseUser = {
      ...response.data,
      initials: getInitials(response.data.name),
    };

    if (!currentWorkspaceId) {
      dispatch(setUserCurrentWorkspace(baseUser.default_licensing_account_id));
    }

    dispatch(actions.LOAD_CROPWISE_USER.success(baseUser));
  } catch (e) {
    dispatch(actions.LOAD_CROPWISE_USER.error((e as Error)?.message));
  }
};

export const saveUserPreferences = (newProperties: Partial<UserPreferences>) => (
  dispatch,
  getState
) => {
  const state: RootState = getState();
  const { userPreferences } = state.User;

  const updatedPreferences = {
    ...userPreferences,
    ...newProperties,
  };

  dispatch({ type: actions.UPADTE_USER_PREFERENCES, payload: updatedPreferences });
};
